import type { RoleLookup, StaffLookup } from '../../lib/api/lookups';

/**
 * How `StaffPicker` and `RolePicker` name an option. In their own module
 * because a component file that also exports functions breaks Vite's Fast
 * Refresh (`react-refresh/only-export-components`).
 */

/** "Full Name — username": the name to recognise, the username to tell two Sara Ahmeds apart. */
export function staffOptionLabel(person: StaffLookup): string {
  return `${person.full_name} — ${person.username}`;
}

/** The label in the UI language — the `startsWith('ar')` rule `referenceName()` uses (i18next may resolve `ar-SA`). */
export function roleOptionLabel(role: RoleLookup, language: string): string {
  return language.startsWith('ar') ? role.label_ar : role.label_en;
}
